let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("biuin")).then(() => parcelRequire('jBLt3'));